import { gql, GraphQLClient } from 'graphql-request';

import { NetworkIds } from '~config/rpcConfig';

export default class SavingModule {
  constructor(private readonly client: GraphQLClient, private readonly networkId: NetworkIds) {}

  async getSavingModuleRewards() {
    const savingModuleRewardQuery = gql`
      query get_saving_module_rewards {
        savingModule(id: "only") {
          lastTimestamp
          lastAddedReward
          totalAllocatedVST
          timeBetweenRewards
        }
      }
    `;

    const res: {
      savingModule: {
        lastTimestamp: number;
        lastAddedReward: string;
        totalAllocatedVST: string;
        timeBetweenRewards: number;
      };
    } = await this.client.request(savingModuleRewardQuery);

    return res.savingModule;
  }
}
